<template>
  <RNServiceDetails />
</template>
<script>
import RNServiceDetails from '@/components/dashboard/repairNetwork/RN_ServiceDetails.vue'
export default {
  name: 'RepairNetworkHost',
  components: {
    RNServiceDetails
  }
}
</script>
<style lang="scss" scoped></style>
